import { atom } from "recoil";

export const SelectedContactsAtom = atom<string[]>({
  key: "SelectedContacts",
  default: [""],
});

export const SelectedContactsOnCampaignAtom = atom<string[]>({
  key: "SelectedContactsOnCampaignAtom",
  default: [],
});

export const ExcludeContactIdsAtom = atom<string[]>({
  key: "ExcludeContactIdsAtom",
  default: [],
});
